import { Component } from '@angular/core';
import { SupportService } from 'src/app/core/services/support.service';

@Component({
  selector: 'app-support-link-v2',
  standalone: true,
  templateUrl: './support-link.component.html',
  styleUrls: ['./support-link.component.scss'],
})
export class SupportLinkV2Component {
  constructor(public supportService: SupportService) {}
}
